(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dales-vehicle-parts"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const bar = document.getElementById('dm-vehicle-parts');
    if (!bar) return;
    const category = bar.querySelector('#dm-part-category');
    const subcategory = bar.querySelector('#dm-part-subcategory');
    const brand = bar.querySelector('#dm-part-brand');
    const allowed = new Set(['performance-air-intake-systems','brake-upgrades-canada','cooling-system-upgrades','performance-drivetrain-upgrades-canada','engine-upgrades-canada','exhaust-system-upgrades-canada','turbo-upgrades','fuel-system-upgrades','performance-suspension-upgrades-canada','tuning-programmers','wheel-upgrades-spacers-canada'].map(h => '/collections/' + h));
    let groups = [], signature = '', queued = false;
    function filters() {
      const raw = location.search.slice(1).split('/');
      const result = [];
      for (let i = 0; i + 1 < raw.length; i += 2) {
        if (['Year','Make','Model','Submodel'].includes(raw[i])) result.push(raw[i], raw[i + 1]);
      }
      return result;
    }
    function navigate(path, vendor) {
      const pieces = filters();
      if (vendor) pieces.unshift('vendor', encodeURIComponent(vendor));
      location.assign(path + (pieces.length ? '?' + pieces.join('/') : ''));
    }
    function options(select, entries, selected) {
      select.replaceChildren(...entries.map(([value, label]) => {
        const option = document.createElement('option');
        option.value = value; option.textContent = label; return option;
      }));
      select.value = selected;
    }
    function update() {
      queued = false;
      const widget = document.querySelector('#cm-collection-page .cm_vehicle-widget, #cm_results .cm_vehicle-widget');
      if (!widget) { bar.hidden = true; return; }
      if (widget.nextElementSibling !== bar) widget.insertAdjacentElement('afterend', bar);
      bar.hidden = false;
      const seen = new Set();
      groups = Array.from(document.querySelectorAll('.menu-lv-1')).map(li => {
        const a = li.querySelector(':scope > p > a');
        if (!a || !allowed.has(a.getAttribute('href')) || seen.has(a.getAttribute('href'))) return null;
        const path = a.getAttribute('href'); seen.add(path);
        const links = new Map();
        li.querySelectorAll('.site-nav-dropdown a[href^="/collections/"]').forEach(link => {
          const href = link.getAttribute('href');
          if (href !== path) links.set(href, link.textContent.trim());
        });
        return {path, title:a.textContent.trim(), links:Array.from(links)};
      }).filter(Boolean);
      const current = groups.find(g => g.path === location.pathname || g.links.some(([path]) => path === location.pathname));
      const brands = [...new Set(Array.from(document.querySelectorAll('.cm_field-vendor .facetentrykey')).map(a => a.textContent.trim()).filter(Boolean))].sort((a,b) => a.localeCompare(b));
      const raw = location.search.slice(1).split('/');
      const vendorIndex = raw.indexOf('vendor');
      let selectedBrand = '';
      if (vendorIndex >= 0) { try { selectedBrand = decodeURIComponent(raw[vendorIndex + 1] || ''); } catch (_) {} }
      if (selectedBrand && !brands.includes(selectedBrand)) brands.push(selectedBrand);
      const vehicle = filters();
      document.querySelectorAll('.dm-parts-categories nav a[href], .dm-parts-wide-links a[href], .dm-parts-feature-link[href], [data-dm-original-description] .opts a[href]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.href);
        if (url.origin === location.origin && url.pathname.startsWith('/collections/')) {
          const existing = url.search.slice(1).split('/');
          const vendorAt = existing.indexOf('vendor');
          const pieces = vendorAt >= 0 && existing[vendorAt + 1] ? ['vendor',existing[vendorAt + 1],...vehicle] : selectedBrand ? ['vendor',encodeURIComponent(selectedBrand),...vehicle] : vehicle;
          const href = url.pathname + (pieces.length ? '?' + pieces.join('/') : '') + url.hash;
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        }
      });
      const vehicleText = vehicle.filter((_,i) => i % 2).map(value => {
        try { return decodeURIComponent(value).replace(/-/g,' '); } catch (_) { return value; }
      }).join(' ');
      const partTitle = document.querySelector('.dm-parts-copy h1')?.textContent.trim() || document.title;
      document.querySelectorAll('.dm-parts-fitment[href^="mailto:"]').forEach(link => {
        const address = link.getAttribute('href').split('?')[0];
        const subject = 'Fitment question: ' + (vehicleText || partTitle);
        const body = ['Hello Dale’s,','', 'Please help me confirm fitment.', 'Vehicle: ' + (vehicleText || 'Please enter year, make, model and trim'), 'Parts: ' + partTitle, 'Page: ' + location.origin + location.pathname + location.search, '', 'My question: '].join('\n');
        const href = address + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      });
      const next = JSON.stringify([groups, current?.path, location.pathname, brands, selectedBrand]);
      if (signature === next) return;
      signature = next;
      options(category, [['',bar.dataset.choose], ...groups.map(g => [g.path,g.title])], current?.path || '');
      options(subcategory, current ? [[current.path,bar.dataset.all + ' ' + current.title],...current.links] : [['',bar.dataset.choose]], current ? location.pathname : '');
      subcategory.disabled = !current;
      options(brand, [['',bar.dataset.brands], ...brands.map(b => [b,b])], selectedBrand);
      brand.disabled = !brands.length;
    }
    category.addEventListener('change', () => { if (category.value) navigate(category.value); });
    subcategory.addEventListener('change', () => { if (subcategory.value) navigate(subcategory.value); });
    brand.addEventListener('change', () => navigate(location.pathname, brand.value));
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
    window.addEventListener('popstate', schedule);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
